const errorState = {
}

export default errorState;
